import { runTransaction } from 'firebase/firestore';

export const productArray = (value) => Array.isArray(value) ? value : [];
export function cleanProductData(value) {
  if (Array.isArray(value)) return value.map(item => item === undefined ? null : cleanProductData(item));
  if (value && value.constructor === Object) return Object.fromEntries(Object.entries(value)
    .filter(([, item]) => item !== undefined).map(([key, item]) => [key, cleanProductData(item)]));
  return value;
}
function canonical(value) {
  if (value instanceof Date) return { $date: value.toISOString() };
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === 'object') return Object.fromEntries(Object.keys(value).sort().map(key => [key, canonical(value[key])]));
  return value;
}
const withoutId = (value) => { const { id, ...data } = value || {}; return data; };
export const sameProduct = (a, b) => JSON.stringify(canonical(withoutId(a))) === JSON.stringify(canonical(withoutId(b)));
const productError = (code, message) => Object.assign(new Error(message), { code });

// Compare the entire loaded snapshot, including legacy documents with no revision.
// A retry must still compare against the user's original snapshot, never the latest read.
export async function saveProductWithConflictCheck(db, ref, base, changes) {
  if (!base) throw productError('product/not-loaded', '商品尚未載入，請稍後再保存。');
  const patch = cleanProductData(changes);
  ['id', 'newStyle', 'newStyleBarcode', 'newStyleImage', 'originalStyleDetails'].forEach(key => delete patch[key]);
  return runTransaction(db, async transaction => {
    const snapshot = await transaction.get(ref);
    if (!snapshot.exists()) throw productError('product/deleted', '商品已被刪除，未保存本次修改。');
    const current = snapshot.data();
    if (!sameProduct(base, current)) throw productError('product/conflict', '其他人已更新這筆商品。本次內容仍保留在頁面，請先複製修改內容，再重新載入核對；不會覆蓋他人的更新。');
    const update = { ...patch, revision: (Number.isSafeInteger(current.revision) ? current.revision : 0) + 1 };
    transaction.update(ref, update);
    return { ...current, ...update };
  });
}

export async function mergeProductsWithConflictCheck(db, main, candidates, changes) {
  if (candidates.length > 450) throw productError('product/merge-too-large', '一次最多合併 450 筆商品，請分批執行。');
  return runTransaction(db, async transaction => {
    const entries = [main, ...candidates];
    const snapshots = await Promise.all(entries.map(entry => transaction.get(entry.ref)));
    snapshots.forEach((snapshot, index) => {
      if (!snapshot.exists() || !sameProduct(entries[index].base, snapshot.data())) {
        throw productError('product/conflict', '預覽後商品已有變動，未合併也未刪除商品；請重新產生合併預覽。');
      }
    });
    const patch = cleanProductData(changes);
    delete patch.id;
    patch.revision = (Number.isSafeInteger(snapshots[0].data().revision) ? snapshots[0].data().revision : 0) + 1;
    transaction.update(main.ref, patch);
    candidates.forEach(entry => transaction.delete(entry.ref));
  });
}
